
import axios from 'axios'
import cookie from 'vue-cookies'
import { trackContactFormSubmit } from '~/lib/linkedInTracker'

export default {
  data() {
    return {
      firstName: '',
      lastName: '',
      organisation: '',
      formOfContact: '',
      email: '',
      telephone: '',
      preferredContactTime: '',
      message: '',
      isSuccess: false,
      hasFormBeenValidated: false,
    }
  },
  computed: {
    isFormOfContactValid() {
      return !!this.formOfContact
    },
    isTelephoneValid() {
      return this.formOfContact === 'telephone' && this.telephone.length > 6
    },
    isEmailValid() {
      const regex = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
      return this.formOfContact === 'email' && regex.test(this.email)
    },
  },
  methods: {
    async submit() {
      if (this.isFormValid()) {
        trackContactFormSubmit()
        await axios.post(
          `https://api.hsforms.com/submissions/v3/integration/submit/${process.env.hubspotAccountId}/${process.env.hubspotContactFormId}`,
          {
            submittedAt: Date.now().toString(),
            fields: [
              {
                name: 'email',
                value: this.email,
              },
              {
                name: 'firstname',
                value: this.firstName,
              },
              {
                name: 'lastname',
                value: this.lastName,
              },
              {
                name: 'message',
                value: this.message,
              },
              {
                name: 'company',
                value: this.organisation,
              },
              {
                name: 'preferred_time_to_call',
                value: this.preferredContactTime,
              },
              {
                name: 'phone',
                value: this.telephone,
              },
            ],
            context: {
              hutk: cookie.get('hubspotutk'),
              pageUri: 'www.nurole.com/contact',
              pageName: 'Contact page',
            },
          }
        )
        this.isSuccess = true
        window.ga('send', {
          hitType: 'event',
          eventCategory: 'Hubspot form submitted',
          eventAction: 'Submitted contact form',
          eventLabel: window.location.href,
        })
      } else {
        this.isSuccess = false
      }
    },
    isFormValid() {
      this.hasFormBeenValidated = true

      return this.isEmailValid || this.isTelephoneValid
    },
  },
}
